export const FETCH_DISPATCH = "FETCH_DISPATCH";

export const CREATE_DISPATCH = "CREATE_DISPATCH";

export const DELETE_DISPATCH = "DELETE_DISPATCH";

export const UPDATE_DISPATCH = "UPDATE_DISPATCH";

export const COPY_ITEM = "COPY_ITEM";

export const PASTE_ITEM = "PASTE_ITEM";

export const UPDATE_TEAM_JOB = "UPDATE_TEAM_JOB";

export const COPY_DISPATCHES = "COPY_DISPATCHES";

export const PASTE_DISPATCHES = "PASTE_DISPATCHES";

export const REORDER_DISPATCHES = "REORDER_DISPATCHES";

export const REORDER_JOBS = "REORDER_JOBS";

export const CHANGE_DATE = "CHANGE_DATE";

export const ADD_COPY_TEAMS = "ADD_COPY_TEAMS";

export const COPY_ALL_TEAMS = "COPY_ALL_TEAMS";

export const PASTE_TEAMS = "PASTE_TEAMS";

export const UPDATE_TEAMS_VISIBILITY = "UPDATE_TEAMS_VISIBILITY";

export const ADD_JOBS = "ADD_JOBS";

export const DELETE_JOBS = "DELETE_JOBS";
